import { uniq } from 'lodash';

import { ComboField } from '~/components/form';
import { FilterDrawer } from '~/components/ui';
import { joinValues, splitValues } from '~/lib/listParams';
import type { MlsRow } from '~/components/Constants/mlsConstants';

/** The drawer's fields: the URL key, the feed field it matches, and its label. */
export const FEED_FILTER_FIELDS = [
  { param: 'feedId', field: '_id', title: 'Platform feed ID' },
  { param: 'dataServer', field: 'dataServer', title: 'Data server' },
  { param: 'dmServer', field: 'dmServer', title: 'DM server' },
  { param: 'serverBucket', field: 'serverBucket', title: 'Server/bucket' },
] as const;

type FeedFilters = Record<string, string>;

interface MlsDrawerProps {
  open: boolean;
  onClose: () => void;
  /** The applied filters by URL key; each is a `joinValues` list. */
  value: FeedFilters;
  onApply: (filters: FeedFilters) => void;
  onClear: () => void;
  rows: MlsRow[];
}

export default function MlsDrawer({
  open,
  onClose,
  value,
  onApply,
  onClear,
  rows,
}: MlsDrawerProps) {
  return (
    <FilterDrawer<FeedFilters>
      open={open}
      onClose={onClose}
      value={value}
      onApply={onApply}
      onClear={onClear}
      testId="feeds-filter-drawer"
    >
      {(draft, patch) =>
        FEED_FILTER_FIELDS.map(({ param, field, title }) => (
          <ComboField
            key={param}
            id={`feeds-filter-${param}`}
            label={title}
            isMulti
            selectAll
            value={splitValues(draft[param])}
            onChange={(values) => patch({ [param]: joinValues(values) })}
            options={uniq(rows.map((row) => row[field] as string | undefined).filter(Boolean)).map(
              (option) => ({ label: option as string, value: option as string }),
            )}
          />
        ))
      }
    </FilterDrawer>
  );
}
